import React, { useState } from 'react';
import classNames from 'classnames';
import { showModal } from '../Modal';
import Dialog from '../Dialog';
import './index.scss';

const CommonInputModal = ({
  initialInputValue,
  confirmCallback,
  title,
  placeholder,
  tips,
  bottomTips,
  minLength = 1,
  maxLength = 100,
  confirmButtonText = '确认',
}) => {
  const [inputValue, setInputValue] = useState(initialInputValue);

  const handleInput = (e) => {
    // replace非数字
    const v = e.target.value.replace(/[^\d]/g, '').slice(0, maxLength);
    setInputValue(v);
  };

  const handleConfirm = () => {
    confirmCallback(inputValue);
  };

  return (
    <Dialog
      confirmButtonText={confirmButtonText}
      confirmCallback={handleConfirm}
      title={title}
      keyboard={{ onEnter: handleConfirm, allowEnterInInput: true }}
    >
      <>
        <div className="common-input-dialog">
          {tips ? <div className="common-input-dialog__tips">{tips}</div> : null}
          <input
            className={classNames('input', {
              'input-with-tips': tips,
            })}
            type="number"
            pattern="\d+"
            placeholder={placeholder}
            minLength={minLength}
            maxLength={maxLength}
            defaultValue={initialInputValue}
            onChange={handleInput}
            value={inputValue}
          />
        </div>
        {bottomTips ? <div className="common-input-dialog__tips">{bottomTips}</div> : null}
      </>
    </Dialog>
  );
};

export const showCommonInputModal = ({
  initialInputValue = '',
  confirmCallback,
  title,
  placeholder,
  minLength,
  maxLength,
  tips = '',
  bottomTips = '',
  confirmButtonText,
}) =>
  showModal(
    <CommonInputModal
      initialInputValue={initialInputValue}
      confirmCallback={confirmCallback}
      title={title}
      tips={tips}
      bottomTips={bottomTips}
      placeholder={placeholder}
      minLength={minLength}
      maxLength={maxLength}
      confirmButtonText={confirmButtonText}
    />,
  );

export default CommonInputModal;
